import React, {FC} from "react"
import Flex from "@irati/ui/src/Flex"
import Link from "@irati/ui/src/Link"
import Button from "@irati/ui/src/Button"
import {Body, H2, H4} from "@irati/ui/src/Typography"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import stopPropagation from "@irati-web/wallet/src/utils/stopBubbleEvent"

import RewardWalletAssetOne from "../../images/reward_wallet_modal_asset_01.svg"
import RewardWalletAssetTwo from "../../images/reward_wallet_modal_asset_02.svg"
import RewardWalletAssetThree from "../../images/reward_wallet_modal_asset_03.svg"

interface Props extends InjectIntl {
  closeModal: () => void
}

const RewardsModalContent: FC<Props> = ({formatMessage, closeModal}) => {
  return (
    <>
      <Flex>
        <H2 marginBottom={1}>
          <FormattedMessage id="platform.reward.user.rewardsModal.title" />
        </H2>
      </Flex>
      <Flex>
        <FormattedMessage
          id="platform.wallet.TreatTokensModal.bodyWithUrl"
          values={{
            url: (
              <Link onClick={stopPropagation} href={formatMessage({id: "platform.wallet.TreatTokensModal.href"})} target="_blank" cta>
                <FormattedMessage id="platform.wallet.TreatTokensModal.hrefText" />
              </Link>
            )
          }}
        />
      </Flex>
      <Flex alignItems="center" marginBottom={3} marginTop={3}>
        <img src={RewardWalletAssetOne} alt="asset-one" />
        <Flex direction="column" marginLeft={2}>
          <H4 marginBottom={1}>
            <FormattedMessage id="platform.reward.user.rewardsModal.body.questionOne" />
          </H4>
          <Body small>
            <FormattedMessage id="platform.reward.user.rewardsModal.body.answerOne" />
          </Body>
        </Flex>
      </Flex>
      <Flex alignItems="center" marginBottom={3}>
        <img src={RewardWalletAssetTwo} alt="asset-two" />
        <Flex direction="column" marginLeft={2}>
          <H4 marginBottom={1}>
            <FormattedMessage id="platform.reward.user.rewardsModal.body.questionTwo" />
          </H4>
          <Body small>
            <FormattedMessage id="platform.reward.user.rewardsModal.body.answerTwo" />
          </Body>
        </Flex>
      </Flex>
      <Flex alignItems="center" marginBottom={3}>
        <img src={RewardWalletAssetThree} alt="asset-three" />
        <Flex direction="column" marginLeft={2}>
          <H4 marginBottom={1}>
            <FormattedMessage id="platform.reward.user.rewardsModal.body.questionThree" />
          </H4>
          <Body small>
            <FormattedMessage id="platform.reward.user.rewardsModal.body.answerThree" />
          </Body>
        </Flex>
      </Flex>
      <Button primary full large onClick={closeModal}>
        <FormattedMessage id="platform.wallet.TreatTokensModal.button.gotIt" />
      </Button>
    </>
  )
}

export default injectIntl(RewardsModalContent)
